module.exports = __webpack_public_path__ + "img/broadband-result-medium.2e70a0eb.svg";